module.exports = __webpack_public_path__ + "img/sld_scb_1_green.50a187d6.svg";